import React from 'react';
import PropTypes from 'prop-types';

const getStyle = props => {
  const { color } = props;
  return {
    display: 'block',
    backgroundColor: color,
    width: `100%`
  };
};

const Image = props => (
  <div className={props.className} style={getStyle(props)} />
);

Image.propTypes = {
  color: PropTypes.string.isRequired,
  className: PropTypes.string
};

Image.defaultProps = {
  className: ''
};

export default Image;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/components/Image/Image.js